import { ISelectOption } from "src/@types/form";
import { Roles } from "src/@types/users";
import { registrationOptionstTrns } from "../trns";

export const ROLE_OPTIONS: ISelectOption[] = [
  {
    label: { i18nKey: registrationOptionstTrns.businessOwner },
    id: Roles.OWNER,
    value: Roles.OWNER,
  },

  {
    label: { i18nKey: registrationOptionstTrns.agent },
    id: Roles.AGENT,
    value: Roles.AGENT,
  },
];

export const INTERNATIONAL_OPTION: ISelectOption[] = [
  { label: { i18nKey: registrationOptionstTrns.yes }, id: "yes", value: true },
  { label: { i18nKey: registrationOptionstTrns.no }, id: "no", value: false },
];
